import type { IAdLink, IBanner } from '@/assets/types/api/Banners';
import type { IHomeCategory } from '@/assets/types/api/Categories';

export const useHomeStore = defineStore('homeStore', () => {
  const nuxtApp = useNuxtApp();

  /* State */

  const banners = ref<IBanner[]>([]);
  const adLinks = ref<IAdLink[]>([]);
  const products = ref<IHomeCategory[]>([]);

  /* Actions */

  const USE_GET_BANNERS = async () => {
    /**
     * 取得首頁 Banner 及 AD Links 資料
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    return await useCustomFetch(
      () => `/marketplace/api/v1/banners?websiteCode=${locale.value}`,
      {
        method: 'GET',
        lazy: true,
        immediate: true,
        onResponse: ({ response }) => {
          const { _data, status } = response;
          const data = _data as { banners: IBanner[]; adLinks: IAdLink[] };

          if (status >= 200 && status < 300) {
            banners.value = [...data.banners];
            adLinks.value = [...data.adLinks];
          } else {
            console.error(_data);
            $notification({
              message: (_data as { message: string }).message,
              type: 'error',
            });
          }
        },
      }
    );
  };

  const USE_GET_HOME_CATEGORY = async () => {
    /**
     * 取得首頁的產品分類及產品清單
     */
    const { $i18n, $notification } = nuxtApp;
    const { locale } = $i18n;

    return await useCustomFetch(
      () =>
        `/marketplace/api/v1/product-categories/home?websiteCode=${locale.value}`,
      {
        method: 'GET',
        lazy: true,
        immediate: true,
        onResponse: ({ response }) => {
          const { _data, status } = response;

          if (status >= 200 && status < 300) {
            products.value = [...(_data as IHomeCategory[])];
          } else {
            console.error(_data);
            $notification({
              message: (_data as { message: string }).message,
              type: 'error',
            });
          }
        },
      }
    );
  };

  return {
    banners,
    adLinks,
    products,
    USE_GET_BANNERS,
    USE_GET_HOME_CATEGORY,
  };
});
